// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"158":"labels","377":"purchases","549":"locations","594":"about","697":"purchaseOrderDetail"}[chunkId] || chunkId) + "." + {"158":"f6f1d938","329":"9099786d","377":"d1ec70bf","549":"0648434f","594":"b787eaba","697":"ed87438e"}[chunkId] + ".css";
};